import { useQueryClient } from '@tanstack/react-query'
import { useContext } from 'react'
import { useLocation, useNavigate as _useNavigate } from 'react-router'
import type { NavigateFunction, NavigateOptions, To } from 'react-router'
import { match } from 'path-to-regexp'

import { MODALS_ID, QUERY_KEY } from '../constants'

import { toggleTab } from '../utils/toggleTab'

import { ModalContext } from '../provider/ModalProvider'

import { IsSignInModal } from '../components/modals/IsSignInModal'

import { PROTECTED_ROUTES } from '../routes/protectedRoutes'

const PROTECTED_ROUTE_PATHS = PROTECTED_ROUTES.map(({ path }) => path)

export function useNavigate() {
  const { openModal } = useContext(ModalContext)

  const queryClient = useQueryClient()
  const location = useLocation()
  const _navigate = _useNavigate()

  const navigate: NavigateFunction = (props: To | number, option?: NavigateOptions) => {
    if (typeof props === 'number') {
      // history length가 2이하(새창에서 새롭게 접근했을때)에서 뒤로가기 하면 home으로 이동
      if (props < 0 && window.history.length <= 2) {
        _navigate('/home')
        return
      }
      _navigate(props)
      return
    }

    const requiredLogin = PROTECTED_ROUTE_PATHS.some((path) => {
      if (!path) {
        return false
      }

      const matcher = match(path, { decode: decodeURIComponent })
      const url = typeof props === 'string' ? props : (props.pathname ?? '')
      return matcher(url) !== false
    })

    const userInfo = queryClient.getQueryData([QUERY_KEY.userInfo])

    if (process.env.NODE_ENV === 'development') {
      console.log({ requiredLogin, userInfo })
      console.log({ location })
    }

    if (requiredLogin && !userInfo) {
      toggleTab(location.pathname)
      openModal({ id: MODALS_ID.IS_SIGNIN, Component: IsSignInModal })
      return
    }

    _navigate(props as keyof NavigateFunction, option)
  }

  return navigate
}
